import { fetchLocaleFromPath } from '../fetchLocaleFromPath';

export function stripLocaleFromPath(pathname: string, locales: string[]) {
  // A valid locale, or undefined if no locale exists in path
  const existingLocale = fetchLocaleFromPath(pathname, locales);

  if (!existingLocale || !locales.includes(existingLocale)) {
    // there's no locale, return the original pathname
    return pathname;
  }

  // Return the pathname without the locale
  return '/' + pathname.split('/').slice(2).join('/');
}
